import { useState, createContext } from "react";

export const AlertContext = createContext();

export const AlertProvider = (props) => {
  const [msg, setMsg] = useState(null);
  const [severity, setSeverity] = useState(null);
  const [duration, setDuration] = useState(3000);

const showAlert = (msg, severity, duration = 3000) => {
  setSeverity(severity);
  setMsg(msg);
  setDuration(duration);
};

  const hideAlert = () => {
    setMsg(null);
    setSeverity(null);
  };

  const state = {
    msg,
    severity,
  };

  return (
    <AlertContext.Provider
      value={{
        msg: state.msg,
        severity: state.severity,
        duration,
        showAlert,
        hideAlert,
      }}
    >
      {props.children}
    </AlertContext.Provider>
  );
};
